// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__29YC_","tab":"Tabs_tab__1gY8E","tabActive":"Tabs_tabActive__2dDfo"};